module.exports = __webpack_public_path__ + "static/media/idle.c489fe27.svg";